import { connect } from 'react-redux'
import TextArea from '../Components/TextArea'
import { mapStateToProps, mapDispatchToProps } from '../Utils/mapToProps'

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TextArea)
